import {
  Heading as HeadingView,
  SubModule,
  TabsContentModule,
} from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

import { Heading, ModuleContainer } from '../../element';
import { Tabs, TabsRules } from './Tabs';
import { SectionTitle } from '../../element/SectionTitle';

export type TabListContentBlockBehavior = {
  onTabSelected: (tabName: string) => void;
};

export type TabListContentBlockContent = Pick<
  TabsContentModule,
  'badge' | 'heading'
> & {
  modules: Pick<SubModule<unknown>, 'name' | 'position'>[];
  tabGroup: string;
};

export type TabListContentBlockProps = {
  behavior: TabListContentBlockBehavior;
  content: TabListContentBlockContent;
  rules?: TabsRules;
};

export const TabListContentBlock = ({
  behavior,
  content: { badge, heading, modules, tabGroup },
  rules,
}: TabListContentBlockProps) => {
  const { textStyle = Ui.RichTextStyle.Primary } = rules || {};
  const headingContent = heading
    ? ({ level: heading.level || 'h2', ...heading } as HeadingView)
    : undefined;

  return (
    <ModuleContainer>
      <SectionTitle
        content={badge}
        rules={{
          sectionTitle: {
            style: 'default',
          },
          verticalSpacing: { isLargeAtMD: true },
        }}
      />
      <Heading
        content={headingContent}
        rules={{
          textStyle: {
            style: textStyle,
          },
        }}
      />
      <Tabs
        behavior={behavior}
        content={modules}
        rules={{ ...rules, hasBadge: !!badge?.text }}
        tabGroup={tabGroup}
      />
    </ModuleContainer>
  );
};
